import '@trp-beacon-ui-kit/foundation/css/style.css';
import { reactBeaconAccordion } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion';
import { reactBeaconAccordionItem } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-accordion-item';
import { reactBeaconButton } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-button';
import { reactBeaconControl } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control';
import { reactBeaconControlGroup } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-control-group';
import { reactBeaconDividedList } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-divided-list';
import { reactBeaconDividedListItem } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-divided-list-item';
import { reactBeaconError } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-error';
import { reactBeaconIconButton } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-icon-button';
import { reactBeaconLoadingSpinner } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-loading-spinner';
import { reactBeaconModal } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-modal';
import { reactBeaconNotification } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-notification';
import { reactBeaconSegmentedControl } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-segmented-control';
import { reactBeaconSegmentedControlOption } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-segmented-control-option';
import { reactBeaconSelectionTile } from '@trp-beacon-ui-kit/foundation/dist/react/beacon-selection-tile';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/theme-trp.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';

const projectNamePrefix = 'asset-transfer';

export const ATBeaconAccordion = reactBeaconAccordion(projectNamePrefix);
export const ATBeaconAccordionItem = reactBeaconAccordionItem(projectNamePrefix);

export const ATBeaconButton = reactBeaconButton(projectNamePrefix);
export const ATSelectionTile = reactBeaconSelectionTile(projectNamePrefix);
export const ATDividedList = reactBeaconDividedList(projectNamePrefix);
export const ATDividedListItem = reactBeaconDividedListItem(projectNamePrefix);
export const ATBeaconSegmentedControl = reactBeaconSegmentedControl(projectNamePrefix);
export const ATBeaconSegmentedControlOption =
  reactBeaconSegmentedControlOption(projectNamePrefix);
export const ATBeaconControl = reactBeaconControl(projectNamePrefix);
export const ATBeaconControlGroup = reactBeaconControlGroup(projectNamePrefix);
export const ATBeaconError = reactBeaconError(projectNamePrefix);
export const ATBeaconNotification = reactBeaconNotification(projectNamePrefix);
export const ATBeaconIconButton = reactBeaconIconButton(projectNamePrefix);
export const ATBeaconModal = reactBeaconModal(projectNamePrefix);
export const ATBeaconLoadingSpinner = reactBeaconLoadingSpinner(projectNamePrefix);
